import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import user from '@/store/modules/user'
import setting from '@/store/modules/setting'

export default new Vuex.Store({
  modules: {
    user,
    setting
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js